import { getIpHomeAddress } from "~/api/user";

let regionRequest = null;

const getRegionData = response => response?.data?.data || response?.data || response || {};

const isTaiwanRegion = response => {
	const data = getRegionData(response);
	const countryCode = String(data.country_code || data.countryCode || "")
		.trim()
		.toUpperCase();
	const areaCode = String(data.area || data.area_code || "").replace(/\D/g, "");

	return countryCode === "TW" || areaCode === "886" || areaCode.startsWith("886");
};

export function useTaiwanIp() {
	const isTaiwanIp = useState("is-taiwan-ip", () => false);
	const hasCheckedTaiwanIp = useState("has-checked-taiwan-ip", () => false);

	const checkTaiwanIp = async () => {
		if (!import.meta.client) return false;
		if (hasCheckedTaiwanIp.value) return isTaiwanIp.value;

		if (!regionRequest) {
			regionRequest = getIpHomeAddress()
				.then(response => {
					isTaiwanIp.value = isTaiwanRegion(response);
					return isTaiwanIp.value;
				})
				.catch(error => {
					console.error("IP region check failed", error);
					return false;
				})
				.finally(() => {
					hasCheckedTaiwanIp.value = true;
					regionRequest = null;
				});
		}

		return regionRequest;
	};

	onMounted(() => {
		void checkTaiwanIp();
	});

	return {
		isTaiwanIp,
		checkTaiwanIp,
	};
}
